// Product Service Layer
// This service layer uses mock data for the standalone frontend application

// Extended product data with images, sizes, colors for PDP
const mockProducts = [
  {
    id: 1,
    name: "Phone Holder Sakti",
    price: 20.00,
    rating: 4.3,
    reviews: 328,
    brandTag: "Offers",
    brand: "StuffLab",
    brandLogo: "S",
    sku: "PH001ROO-8",
    category: "For Gadgets",
    categoryPath: ["Home", "Gadgets", "Phone Accessories"],
    description: "Premium phone holder with adjustable angles and anti-slip base. Perfect for your desk, bedside, or car dashboard. Made with high-quality materials for durability.",
    features: [
      "360° rotation support",
      "Anti-slip silicone base",
      "Compatible with all phone sizes",
      "Foldable design for portability"
    ],
    images: [
      "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "White", hex: "#f5f5f5" },
      { name: "Gray", hex: "#6b7280" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 2,
    name: "Headsound Pro",
    price: 22.00,
    rating: 4.5,
    reviews: 256,
    brandTag: "More",
    brand: "StuffLab",
    brandLogo: "S",
    sku: "HS002PRO-5",
    category: "For Audio",
    categoryPath: ["Home", "Audio", "Headphones"],
    description: "Premium over-ear headphones with active noise cancellation. Experience immersive sound with deep bass and crystal-clear highs. Comfortable memory foam ear cushions for extended listening sessions.",
    features: [
      "Active Noise Cancellation",
      "40mm dynamic drivers",
      "30-hour battery life",
      "Bluetooth 5.0 connectivity"
    ],
    images: [
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1546435770-a3e426bf472b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "White", hex: "#f5f5f5" },
      { name: "Silver", hex: "#c0c0c0" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 3,
    name: "Adudu Cleaner",
    price: 29.90,
    rating: 4.7,
    reviews: 189,
    brandTag: "Offers",
    brand: "Adudu",
    brandLogo: "A",
    sku: "AC003CLN-2",
    category: "For Home",
    categoryPath: ["Home", "Appliances", "Cleaners"],
    description: "Smart robot vacuum cleaner with advanced navigation system. Automatically cleans your home with powerful suction and intelligent mapping technology.",
    features: [
      "Smart navigation system",
      "2500Pa suction power",
      "Auto-charging dock",
      "App control & scheduling"
    ],
    images: [
      "https://images.unsplash.com/photo-1550009158-9ebf69173e03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "White", hex: "#f5f5f5" },
      { name: "Black", hex: "#1a1a1a" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1550009158-9ebf69173e03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 4,
    name: "CCTV Maing",
    price: 20.00,
    rating: 4.8,
    reviews: 503,
    brandTag: "Store",
    brand: "Maing",
    brandLogo: "M",
    sku: "CT004SEC-1",
    category: "For Security",
    categoryPath: ["Home", "Security", "Cameras"],
    description: "High-definition security camera with night vision and two-way audio. Monitor your home from anywhere with the companion mobile app.",
    features: [
      "1080p Full HD recording",
      "Night vision up to 30ft",
      "Two-way audio",
      "Motion detection alerts"
    ],
    images: [
      "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "White", hex: "#f5f5f5" },
      { name: "Black", hex: "#1a1a1a" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 5,
    name: "Stuffus Peker 32",
    price: 9.90,
    rating: 4.2,
    reviews: 412,
    brandTag: "Offers",
    brand: "StuffLab",
    brandLogo: "S",
    sku: "SP005AUD-3",
    category: "For Audio",
    categoryPath: ["Home", "Audio", "Earbuds"],
    description: "Compact wireless earbuds with premium sound quality. Ergonomic design for comfortable all-day wear with secure fit.",
    features: [
      "True wireless design",
      "IPX5 water resistance",
      "Touch controls",
      "24-hour total battery"
    ],
    images: [
      "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1546435770-a3e426bf472b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "White", hex: "#f5f5f5" },
      { name: "Blue", hex: "#3b82f6" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: false,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 6,
    name: "Stuffus RT75",
    price: 34.90,
    rating: 4.6,
    reviews: 178,
    brandTag: "More",
    brand: "StuffLab",
    brandLogo: "S",
    sku: "SR006TRV-7",
    category: "For Travel",
    categoryPath: ["Home", "Travel", "Accessories"],
    description: "Premium travel case with multiple compartments for organizing your tech gadgets. Durable construction with water-resistant exterior.",
    features: [
      "Water-resistant material",
      "Multiple compartments",
      "Cable management slots",
      "Compact & portable"
    ],
    images: [
      "https://images.unsplash.com/photo-1546435770-a3e426bf472b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: ["Small", "Medium", "Large"],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Navy", hex: "#1e3a5f" },
      { name: "Gray", hex: "#6b7280" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1546435770-a3e426bf472b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 7,
    name: "TWS Rajug",
    price: 29.00,
    rating: 4.4,
    reviews: 445,
    brandTag: "Offers",
    brand: "Rajug",
    brandLogo: "R",
    sku: "TR007AUD-4",
    category: "For Audio",
    categoryPath: ["Home", "Audio", "Earbuds"],
    description: "True wireless stereo earbuds with active noise cancellation. Premium audio experience in a compact design.",
    features: [
      "Active Noise Cancellation",
      "Transparency mode",
      "Wireless charging case",
      "6-hour playtime"
    ],
    images: [
      "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "White", hex: "#f5f5f5" },
      { name: "Black", hex: "#1a1a1a" },
      { name: "Orange", hex: "#f97316" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 8,
    name: "Headesurd Baytis",
    price: 32.00,
    rating: 4.1,
    reviews: 234,
    brandTag: "Offers",
    brand: "Baytis",
    brandLogo: "B",
    sku: "HB008AUD-6",
    category: "For Audio",
    categoryPath: ["Home", "Audio", "Headphones"],
    description: "Studio-quality over-ear headphones with balanced sound signature. Perfect for music production and critical listening.",
    features: [
      "Studio-grade drivers",
      "Foldable design",
      "Detachable cable",
      "Memory foam cushions"
    ],
    images: [
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1546435770-a3e426bf472b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "White", hex: "#f5f5f5" },
      { name: "Red", hex: "#ef4444" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1583394838336-acd977736f90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 9,
    name: "Pro Camera X1",
    price: 45.00,
    rating: 4.9,
    reviews: 892,
    brandTag: "Featured",
    brand: "ProTech",
    brandLogo: "P",
    sku: "PC009SEC-9",
    category: "For Security",
    categoryPath: ["Home", "Security", "Cameras"],
    description: "Professional-grade security camera with 4K resolution and AI-powered detection. The ultimate home security solution.",
    features: [
      "4K Ultra HD recording",
      "AI motion detection",
      "Color night vision",
      "Cloud & local storage"
    ],
    images: [
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "White", hex: "#f5f5f5" },
      { name: "Black", hex: "#1a1a1a" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 10,
    name: "Smart Speaker Z",
    price: 55.00,
    rating: 4.7,
    reviews: 567,
    brandTag: "New",
    brand: "SmartZ",
    brandLogo: "Z",
    sku: "SS010HOM-2",
    category: "For Home",
    categoryPath: ["Home", "Smart Home", "Speakers"],
    description: "Voice-controlled smart speaker with premium 360° sound. Control your smart home with just your voice.",
    features: [
      "Voice assistant built-in",
      "360° room-filling sound",
      "Multi-room audio",
      "Smart home hub"
    ],
    images: [
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1550009158-9ebf69173e03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Charcoal", hex: "#374151" },
      { name: "Sand", hex: "#d4c4b0" },
      { name: "Sage", hex: "#9ca38f" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxoZWFkcGhvbmVzfGVufDB8fHx8MTc3MDczNjA0N3ww&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 11,
    name: "Wireless Charger",
    price: 15.00,
    rating: 4.3,
    reviews: 312,
    brandTag: "Store",
    brand: "StuffLab",
    brandLogo: "S",
    sku: "WC011GAD-5",
    category: "For Gadgets",
    categoryPath: ["Home", "Gadgets", "Chargers"],
    description: "Fast wireless charging pad compatible with all Qi-enabled devices. Sleek design with LED indicator.",
    features: [
      "15W fast charging",
      "Qi certified",
      "LED status indicator",
      "Anti-slip surface"
    ],
    images: [
      "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "White", hex: "#f5f5f5" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: false,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 12,
    name: "USB Hub Pro",
    price: 25.00,
    rating: 4.5,
    reviews: 289,
    brandTag: "More",
    brand: "StuffLab",
    brandLogo: "S",
    sku: "UH012GAD-8",
    category: "For Gadgets",
    categoryPath: ["Home", "Gadgets", "Accessories"],
    description: "7-port USB hub with fast data transfer and power delivery. Expand your connectivity with style.",
    features: [
      "7 USB 3.0 ports",
      "100W power delivery",
      "Aluminum body",
      "LED indicators"
    ],
    images: [
      "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1678852524356-08188528aed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: [],
    colors: [
      { name: "Silver", hex: "#c0c0c0" },
      { name: "Space Gray", hex: "#4a5568" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwZ2FkZ2V0c3xlbnwwfHx8fDE3NzA3MzYwMjh8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  },
  {
    id: 13,
    name: "Shoes Reebok Zig Kinetica 3",
    price: 199.00,
    rating: 4.5,
    reviews: 42,
    brandTag: "Featured",
    brand: "Reebok",
    brandLogo: "R",
    sku: "HR025ROO-8",
    category: "Shoes",
    categoryPath: ["Clothes and shoes", "Shoes", "Reebok"],
    description: "The Reebok Zig Kinetica 3 features Floatride Energy Foam for responsive cushioning and the iconic zigzag sole for energy return. Perfect for running and everyday wear.",
    features: [
      "Floatride Energy Foam cushioning",
      "Zigzag energy return sole",
      "Breathable mesh upper",
      "Lightweight construction"
    ],
    images: [
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzbmVha2Vyc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxzbmVha2Vyc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxzbmVha2Vyc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1600185365926-3a2ce3cdb9eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxzbmVha2Vyc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
      "https://images.unsplash.com/photo-1584735175315-9d5df23860e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw1fHxzbmVha2Vyc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=800"
    ],
    availableSizes: ["40.5", "42", "42", "43", "43.5", "44", "40.5", "45", "46"],
    colors: [
      { name: "White", hex: "#f5f5f5", image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?crop=entropy&cs=srgb&fm=jpg&w=100" },
      { name: "Gray", hex: "#9ca3af", image: "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?crop=entropy&cs=srgb&fm=jpg&w=100" },
      { name: "Black", hex: "#1a1a1a", image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?crop=entropy&cs=srgb&fm=jpg&w=100" }
    ],
    imageUrl: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzbmVha2Vyc3xlbnwwfHx8fDE3NzA3MzYwMzZ8MA&ixlib=rb-4.1.0&q=85&w=400",
    freeDelivery: true,
    freeDeliveryMin: 30.0,
    inStock: true
  }
];

const categories = [
  { id: "all", name: "All Products", icon: "grid", count: mockProducts.length },
  { id: "for-gadgets", name: "For Gadgets", icon: "smartphone", count: 3 },
  { id: "for-audio", name: "For Audio", icon: "headphones", count: 5 },
  { id: "for-home", name: "For Home", icon: "home", count: 2 },
  { id: "for-security", name: "For Security", icon: "shield", count: 2 },
  { id: "for-travel", name: "For Travel", icon: "briefcase", count: 1 },
  { id: "shoes", name: "Shoes", icon: "shoe", count: 1 }
];

const filters = [
  { id: "new-arrival", name: "New Arrival", icon: "sparkles" },
  { id: "recomended", name: "Recomended", icon: "thumbs-up" },
  { id: "on-discount", name: "OnDiscount", icon: "percent" }
];

const sortOptions = [
  { id: "featured", name: "Featured" },
  { id: "favorites", name: "Favorites" },
  { id: "on-discount", name: "OnDiscount" }
];

const priceRanges = [
  { id: "all", label: "All Prices", min: 0, max: Infinity },
  { id: "under-20", label: "Under $20", min: 0, max: 20 },
  { id: "20-30", label: "$20 - $30", min: 20, max: 30 },
  { id: "30-50", label: "$30 - $50", min: 30, max: 50 },
  { id: "over-50", label: "Over $50", min: 50, max: Infinity }
];

// Simulated API delay for realistic async behavior
const simulateDelay = (ms = 300) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Fetch all products
 * @returns {Promise<Array>} Array of products
 */
export const getProducts = async () => {
  await simulateDelay();
  return [...mockProducts];
};

/**
 * Fetch a single product by ID with full details
 * @param {number|string} id - Product ID
 * @returns {Promise<Object|null>} Product object with full details or null
 */
export const getProductById = async (id) => {
  await simulateDelay(300);
  const numId = typeof id === 'string' ? parseInt(id, 10) : id;
  const product = mockProducts.find(p => p.id === numId);
  return product || null;
};

/**
 * Fetch products with filters
 * @param {Object} filters - Filter options
 * @returns {Promise<Array>} Filtered products
 */
export const getFilteredProducts = async ({ 
  category = "all", 
  priceRange = "all", 
  searchQuery = "",
  sortBy = "featured"
}) => {
  await simulateDelay();
  
  let filtered = [...mockProducts];
  
  // Filter by category
  if (category && category !== "all") {
    const categoryName = category.replace(/-/g, " ").replace(/\b\w/g, l => l.toUpperCase());
    filtered = filtered.filter(p => 
      p.category.toLowerCase().replace(/\s+/g, "-") === category ||
      p.category === categoryName
    );
  }
  
  // Filter by price range
  const range = priceRanges.find(r => r.id === priceRange);
  if (range && priceRange !== "all") {
    filtered = filtered.filter(p => p.price >= range.min && p.price < range.max);
  }
  
  // Filter by search query
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filtered = filtered.filter(p => 
      p.name.toLowerCase().includes(query) ||
      p.category.toLowerCase().includes(query) ||
      p.brandTag.toLowerCase().includes(query)
    );
  }
  
  // Sort products
  switch (sortBy) {
    case "price-low":
      filtered.sort((a, b) => a.price - b.price);
      break;
    case "price-high":
      filtered.sort((a, b) => b.price - a.price);
      break;
    case "rating":
      filtered.sort((a, b) => b.rating - a.rating);
      break;
    case "favorites":
      filtered.sort((a, b) => b.reviews - a.reviews);
      break;
    default:
      // Featured - keep original order or sort by rating
      filtered.sort((a, b) => b.rating - a.rating);
  }
  
  return filtered;
};

/**
 * Get all categories
 * @returns {Promise<Array>} Array of categories
 */
export const getCategories = async () => {
  await simulateDelay(100);
  return [...categories];
};

/**
 * Get filter options
 * @returns {Promise<Array>} Array of filter options
 */
export const getFilters = async () => {
  await simulateDelay(100);
  return [...filters];
};

/**
 * Get sort options
 * @returns {Promise<Array>} Array of sort options
 */
export const getSortOptions = async () => {
  await simulateDelay(100);
  return [...sortOptions];
};

/**
 * Get price ranges
 * @returns {Promise<Array>} Array of price ranges
 */
export const getPriceRanges = async () => {
  await simulateDelay(100);
  return [...priceRanges];
};

/**
 * Get recommended products
 * @param {number} limit - Number of products to return
 * @returns {Promise<Array>} Array of recommended products
 */
export const getRecommendedProducts = async (limit = 4) => {
  await simulateDelay();
  const sorted = [...mockProducts].sort((a, b) => b.rating - a.rating);
  return sorted.slice(0, limit);
};

/**
 * Search products
 * @param {string} query - Search query
 * @returns {Promise<Array>} Array of matching products
 */
export const searchProducts = async (query) => {
  await simulateDelay(200);
  if (!query) return [];
  
  const lowerQuery = query.toLowerCase();
  return mockProducts.filter(p => 
    p.name.toLowerCase().includes(lowerQuery) ||
    p.category.toLowerCase().includes(lowerQuery)
  );
};

/**
 * Get related products based on category
 * @param {number} productId - Current product ID
 * @param {number} limit - Number of products to return
 * @returns {Promise<Array>} Array of related products
 */
export const getRelatedProducts = async (productId, limit = 4) => {
  await simulateDelay(200);
  const numId = typeof productId === 'string' ? parseInt(productId, 10) : productId;
  const currentProduct = mockProducts.find(p => p.id === numId);
  if (!currentProduct) return [];
  
  const related = mockProducts
    .filter(p => p.id !== numId && p.category === currentProduct.category)
    .slice(0, limit);
  
  // If not enough related products in same category, add from other categories
  if (related.length < limit) {
    const others = mockProducts
      .filter(p => p.id !== numId && p.category !== currentProduct.category)
      .slice(0, limit - related.length);
    related.push(...others);
  }
  
  return related;
};

export default {
  getProducts,
  getProductById,
  getFilteredProducts,
  getCategories,
  getFilters,
  getSortOptions,
  getPriceRanges,
  getRecommendedProducts,
  searchProducts,
  getRelatedProducts
};
